import { getCurrentBackendUrl, getCurrentEnvironment } from '../../constants';

type SendRequest = (
  path: string,
  options?: RequestInit,
  needToken?: boolean,
  isFormData?: boolean,
  shouldRedirectToLogin?: boolean,
  extraHeaders?: Record<string, string>

) => Promise<Response>;

export const sendRequest:SendRequest = async (
  path,
  options = {},
  needToken = true,
  isFormData = false,
  shouldRedirectToLogin = true,
  extraHeaders = {}
) => {
  const token = localStorage.getItem('bearer');

  // Get current environment for the X-Environment header
  const environment = getCurrentEnvironment();

  const config: RequestInit = {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      'X-Environment': environment, // Add environment header to all requests
      ...extraHeaders,
    },
  };

  if (needToken) {
    (config.headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  if (isFormData) {
    delete (config.headers as Record<string, string>)['Content-Type'];
  }
  
  const response = await fetch(`${getCurrentBackendUrl()}${path}`, config);

  if (response.status === 401 && shouldRedirectToLogin) {
    localStorage.removeItem('bearer');
    console.error('Token expired. Redirecting to login page...');
    window.location.href = '/login';
  }

  return response;
};
